import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const CommonAlert = ({
  title, description, onClose, onAgree,
}) => (
  <div>
    <Dialog
      open
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title
        ? <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        : null}
      {description
        ? (
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
          </DialogContent>
        )
        : null}
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          No
        </Button>
        <Button onClick={onAgree} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  </div>
)

export default CommonAlert
